<template>
   <div>
      <div
         v-if="!mini"
         id="footer-wrap"
         v-observe-visibility="visibilityChanged">
         <div class="container">
            <!-- TrustBox widget - Slider -->
            <div
               ref="trustbox"
               class="trustpilot-widget"
               data-locale="da-DK"
               data-template-id="54ad5defc6454f065c28af8b"
               data-businessunit-id="4f441e530000640005130ce5"
               data-style-height="240px"
               data-style-width="100%"
               data-theme="light"
               data-stars="5"
               data-schema-type="Organization">
               <a
                  href="https://dk.trustpilot.com/review/findforsikring.dk"
                  target="_blank"
                  rel="noopener">
                  Trustpilot
               </a>
            </div>
            <!-- End TrustBox widget -->
         </div>

         <footer class="container position-relative">
            <div class="offset-sm-2 col-sm-8 offset-md-2 col-md-6 menu-wrap clearfix text-center text-md-start">
               <div
                  id="nav_menu-6"
                  class="widget widget_nav_menu">
                  <label>Findforsikring</label>
                  <div class="menu-findforsikring-dk-container">
                     <ul
                        id="menu-findforsikring-dk"
                        class="menu">
                        <li
                           data-id="6424"
                           data-menu-columns="1">
                           <a href="https://www.findforsikring.dk/om-os/"><span>Om os</span></a>
                        </li>
                        <li
                           data-id="6426"
                           data-menu-columns="1">
                           <a href="https://www.findforsikring.dk/kontakt/"><span>Kontakt</span></a>
                        </li>
                        <li
                           data-id="6427"
                           data-menu-columns="1">
                           <a href="https://www.findforsikring.dk/betingelser/"><span>Betingelser</span></a>
                        </li>
                        <li
                           data-id="13336"
                           data-menu-columns="1">
                           <a href="https://www.findforsikring.dk/privatlivspolitik/"><span>Privatlivspolitik</span></a>
                        </li>
                        <li data-menu-columns="1">
                           <a href="https://www.findforsikring.dk/samtykke"><span>Samtykke</span></a>
                        </li>
                        <li
                           data-id="6428"
                           data-menu-columns="1">
                           <a href="https://www.findforsikring.dk/partnere/"><span>Partnere</span></a>
                        </li>
                        <li
                           data-id="8955"
                           data-menu-columns="1">
                           <a href="https://www.findforsikring.dk/job/"><span>Job</span></a>
                        </li>
                     </ul>
                  </div>
               </div>
               <div
                  id="nav_menu-7"
                  class="widget widget_nav_menu">
                  <label>Hjælp</label>
                  <div class="menu-hjaelp-container">
                     <ul
                        id="menu-hjaelp"
                        class="menu">
                        <li
                           data-id="6419"
                           data-menu-columns="1">
                           <a href="https://www.findforsikring.dk/support/"><span>Support</span></a>
                        </li>
                        <li
                           data-id="12081"
                           data-menu-columns="1">
                           <a href="https://www.findforsikring.dk/partnerskab-med-findforsikring/">
                              <span>Bliv partner</span>
                           </a>
                        </li>
                        <li
                           data-id="6420"
                           data-menu-columns="1">
                           <a href="https://www.findforsikring.dk/faq/"><span>FAQ</span></a>
                        </li>
                        <li
                           data-id="666"
                           data-menu-columns="1">
                           <a
                              href="#"
                              @click.prevent="showConsentSettings"
                              class="cc-link">
                              Cookies
                           </a>
                        </li>
                     </ul>
                  </div>
               </div>
               <div
                  id="nav_menu-5"
                  class="widget widget_nav_menu">
                  <label>Presse</label>
                  <div class="menu-presse-container">
                     <ul
                        id="menu-presse"
                        class="menu">
                        <li data-id="6429">
                           <a href="https://www.findforsikring.dk/presse-materiale/"><span>Materiale</span></a>
                        </li>
                        <li data-id="10291">
                           <a href="https://www.findforsikring.dk/presse/"><span>Pressekontakt</span></a>
                        </li>
                        <li data-id="10790">
                           <a href="https://www.findforsikring.dk/pressen-skriver/"><span>Pressen skriver</span></a>
                        </li>
                     </ul>
                  </div>
               </div>
            </div>

            <span
               class="infoarrow arrow2 d-none d-md-block"
               style="z-index: 400; right: 218px">
               Til
               <br />
               top
            </span>
            <span
               class="infoarrow arrow2 d-none d-sm-block d-md-none"
               style="z-index: 400; right: 58px; bottom: 172px">
               Til
               <br />
               top
            </span>
            <span
               class="infoarrow arrow2 d-block d-sm-none"
               style="z-index: 400; right: 7%; bottom: 128px">
               Til
               <br />
               top
            </span>
            <a
               id="footer_home_btn"
               href="https://www.findforsikring.dk/?startGuide=true"
               data-redirect-allowed="false"
               @click.prevent="scrollToTop">
               <div class="metal_bg">
                  <div class="rund_knap">
                     <div class="shine" />
                  </div>
               </div>
            </a>

            <div class="clearfix" />
         </footer>
      </div>
      <div id="footer-wrap2">
         <div
            class="container"
            style="height: 100%">
            <div class="h-100 d-flex align-items-center justify-content-end">
<!--               <div class="text-start">-->
<!--                  <a-->
<!--                     id="contact_no"-->
<!--                     href="#"-->
<!--                     @click.prevent>-->
<!--                     <span class="rasmus-icon phone" />-->
<!--                     86 51 80 00-->
<!--                  </a>-->
<!--               </div>-->
               <div
                  class="text-end"
                  style="color: #2c3e50; font-size: 14px">
                  &copy; 2024 Findforsikring
               </div>
            </div>
         </div>
      </div>
      <!--      <div-->
      <!--         id="fake-spacer"-->
      <!--         style="background-color: red; height: 50px"></div>-->
   </div>
</template>

<script>
export default {
   name: 'MaterialFooter',
   props: {
      mini: {
         type: Boolean,
         default: false,
      },
   },
   methods: {
      scrollToTop() {
         window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth',
         });
      },
      showConsentSettings() {
         window.Cookiebot.show();
      },
      visibilityChanged(visible) {
         if (visible) {
            this.$store.commit('activateTrustpilot');
         }
      },
   },
};
</script>

<style lang="scss" scoped>
@import '~/colors';

#footer-wrap {
   padding-top: 75px;
   padding-bottom: 85px;
   font-style: normal;
   background-image: url(/wp-content/themes/findforsikring_2015-sommer/images/graphics/landskab_ekstra_bakker.png),
      linear-gradient(180deg, rgba(203, 220, 226, 0.6) 0, rgba(188, 215, 226, 0.6) 82%, rgba(138, 200, 226, 0.6));
   filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#99cbdce2",endColorstr="#998ac8e2",GradientType=0);
   background-repeat: repeat-x;
   background-position: bottom;
   box-shadow: inset 0 5px 15px rgb(0 0 0 / 15%);
}

#footer-wrap2 {
   background-color: #fff;
   height: 50px;
   //margin-bottom: -135px;

   a {
      .phone {
         height: 20px;
         width: 20px;
      }

      height: 100%;
      display: flex;
      align-items: center;
      color: $ff-dark-blue;
      //font-family: 'Lato', sans-serif;
      font-weight: bold;
      font-size: 16px;
   }
}

#footer-wrap .menu-wrap .widget {
   float: left;
   margin: 0 0 0 50px;
}

@media (max-width: 767px) {
   #footer-wrap .menu-wrap .widget {
      clear: left;
      float: none;
      margin: 0 0 25px 0;
   }
}

.menu,
.menu ul {
   margin: 0;
   padding: 0;
   list-style: none;
}

//#footer-wrap2 {
//   background-color: #fff;
//   height: 50px;
//   a {
//      .phone {
//         height: 20px;
//         width: 20px;
//      }
//
//      height: 100%;
//      display: flex;
//      align-items: center;
//      color: var(--ff-dark-blue);
//      //font-family: 'Lato', sans-serif;
//      font-weight: bold;
//      font-size: 16px;
//   }
//}
#footer-wrap,
#footer-wrap a {
   color: #2c3e50;
   //font-family: Lato, sans-serif;
   font-style: italic;
}
#footer_home_btn {
   background-position: 0;
   bottom: 105px;
   display: block;
   position: absolute;
   right: 235px;
   transition: 0s;
}
a {
   color: #3490dc;
   text-decoration: none;
   background-color: transparent;
}

#footer-wrap .menu-wrap .widget {
   float: left;
   margin: 0 0 0 50px;
}
#footer_home_btn .metal_bg {
   display: inline-block;
   width: 44px;
   height: 44px;
   border-radius: 30px;
   background: #787878;
   background: linear-gradient(45deg, #787878, #d6d6d6 50%, #c9c9c9 51%, #b4b4b4);
   filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#999999",endColorstr="#e5e5e5",GradientType=1);
   box-shadow: 1px 1px 1px 0 rgb(0 0 0 / 30%);
}
#footer_home_btn .metal_bg .rund_knap {
   margin: 4px auto 0;
   display: block;
   width: 36px;
   height: 36px;
   border-radius: 30px;
   background: #fe960f;
   background: linear-gradient(180deg, #fe960f 0, #ea6604);
   filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#fe960f",endColorstr="#ea6604",GradientType=0);
   box-shadow: 2px 2px 2px 0 rgb(0 0 0 / 40%);
}
#footer_home_btn .metal_bg .rund_knap .shine {
   display: inline-block;
   border-radius: 30px;
   width: 36px;
   height: 36px;
   background: linear-gradient(
      135deg,
      hsla(0, 0%, 100%, 0),
      hsla(0, 0%, 100%, 0.54) 16%,
      hsla(0, 0%, 100%, 0) 24%,
      hsla(0, 0%, 100%, 0) 47%,
      transparent 51%,
      transparent 74%,
      rgba(0, 0, 0, 0.2) 89%,
      transparent
   );
   filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#00ffffff",endColorstr="#00000000",GradientType=1);
}
#footer-wrap .infoarrow.arrow2 {
   cursor: default;
   position: absolute;
   bottom: 155px;
   font-family: Lato, sans-serif;
   line-height: 18px;
   padding: 0 0 5px 22px;
   right: 150px;
   background: url(/wp-content/themes/findforsikring_2015-sommer/images/graphics/arrows/pil_krum.svg) no-repeat 0 100%
      transparent;
   background-size: 18px 28px;
}
#footer-wrap footer {
   min-height: 205px;
   position: relative;
}
#footer-wrap .menu-wrap .widget label {
   color: #2c3e50;
   //font-family: Amaranth,sans-serif;
   font-size: 16px;
   font-weight: 700;
   font-style: normal;
}

@media (max-width: 767px) {
   #footer-wrap .menu-wrap .widget {
      clear: left;
      float: none;
      margin: 0 0 25px 0;
   }
}
@media (max-width: 767px) {
   #footer-wrap #footer_home_btn {
      bottom: 75px;
      right: 10%;
      z-index: 1000;
   }
}
</style>
